<button type="button" [ngClass]="['btn btn-icon', buttonStyle]">{{ label }}<i [ngClass]="['cfe', 'cfe-' + iconName]"></i></button>
